var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('div',{staticClass:"overlay",on:{"click":_vm.close}}),_c('div',{staticClass:"modal",class:("" + _vm.className)},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }